import { Camera, Check } from "lucide-react";

export const ADDON_PRICE = { user: "12.99", vendor: "28" };

export function PhotoAddon({ plan, checked, onChange, testid }) {
  if (plan === "family") {
    return (
      <p data-testid={`${testid}-included`} className="flex items-center gap-2 text-xs text-slate-400">
        <Camera className="h-4 w-4 text-[#00E5A3]" /> 20 profile photos included
      </p>
    );
  }
  return (
    <button type="button" role="checkbox" aria-checked={checked} data-testid={testid} onClick={() => onChange(!checked)}
      className={`w-full flex items-center gap-3 rounded-2xl border p-3 text-left transition-colors ${checked ? "border-[#00E5A3] bg-[#00E5A3]/10" : "border-[#26334D] hover:border-slate-500"}`}>
      <span className={`h-5 w-5 shrink-0 rounded-md border grid place-items-center transition-colors ${checked ? "bg-[#00E5A3] border-[#00E5A3]" : "border-slate-500"}`}>
        {checked && <Check className="h-3.5 w-3.5 text-[#0B0F19]" />}
      </span>
      <span className="text-sm">
        <span className="font-semibold">Add 20 profile photos</span>
        <span className="block text-[11px] text-slate-400">+$3/mo · ${ADDON_PRICE[plan]}/mo total instead of 10 photos</span>
      </span>
    </button>
  );
}
